import { createSlice } from "@reduxjs/toolkit";
import {
  AttendanceData,
  AttendanceInitialStatus,
} from "../../../types/attendance/attendance";
import {
  exportBulkToErp,
  exportCheckInToErp,
  exportCheckOutToErp,
  getAllAttendanceAsync,
  singleAttendanceAsync,
  syncOfflineAttendanceAsync,
  getSyncLogsAsync,
} from "./AttendanceApi";

const initialState: AttendanceInitialStatus<AttendanceData> = {
  loading: false,
  manageLoading: false,
  attendanceData: [],
  singleAttendanceData: null,
  countAttendance: 0,
  syncLogsData: [],
  countSyncLogs: 0,
  syncLogsLoading: false,
};

const attendanceSlice = createSlice({
  name: "admin-attendance",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get all
    builder
      .addCase(getAllAttendanceAsync.pending, (state) => {
        state.loading = true;
        state.attendanceData = [];
      })
      .addCase(getAllAttendanceAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.attendanceData = action.payload.data;
        state.countAttendance = action.payload.length;
      })
      .addCase(getAllAttendanceAsync.rejected, (state) => {
        state.loading = false;
        state.attendanceData = [];
        state.countAttendance = 0;
      });

    // get sync logs
    builder
      .addCase(getSyncLogsAsync.pending, (state) => {
        state.syncLogsLoading = true;
        state.syncLogsData = [];
      })
      .addCase(getSyncLogsAsync.fulfilled, (state, action) => {
        state.syncLogsLoading = false;
        state.syncLogsData = action.payload.data || [];
        state.countSyncLogs = action.payload.length || 0;
      })
      .addCase(getSyncLogsAsync.rejected, (state) => {
        state.syncLogsLoading = false;
        state.syncLogsData = [];
        state.countSyncLogs = 0;
      });

    // single
    builder
      .addCase(singleAttendanceAsync.pending, (state) => {
        state.manageLoading = true;
        state.singleAttendanceData = null;
      })
      .addCase(singleAttendanceAsync.fulfilled, (state, action) => {
        state.manageLoading = false;
        state.singleAttendanceData = action.payload;
      })
      .addCase(singleAttendanceAsync.rejected, (state) => {
        state.manageLoading = false;
        state.singleAttendanceData = null;
      });

    builder
      .addCase(syncOfflineAttendanceAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(syncOfflineAttendanceAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(syncOfflineAttendanceAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // exportCheckInToErp
    builder
      .addCase(exportCheckInToErp.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(exportCheckInToErp.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(exportCheckInToErp.rejected, (state) => {
        state.manageLoading = false;
      });
    // exportCheckOutToErp
    builder
      .addCase(exportCheckOutToErp.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(exportCheckOutToErp.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(exportCheckOutToErp.rejected, (state, action) => {
        state.manageLoading = false;
      });

    // exportBulkToErp
    builder
      .addCase(exportBulkToErp.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(exportBulkToErp.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(exportBulkToErp.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export default attendanceSlice;
